import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || '',

    bg: searchParams.get('bg') || '1',

    title: getDefaultValue(searchParams.get('title'), 'Присылайте фото'),
    qrCode1: searchParams.get('qrCode1'),
    qrCode2: searchParams.get('qrCode2'),

    startFrom: searchParams.get('startFrom')
      ? parseInt(searchParams.get('startFrom') || '')
      : 2,
    duration: searchParams.get('duration')
      ? parseInt(searchParams.get('duration') || '')
      : 10000,
    carousel: searchParams.get('carousel') || '1',
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 10,
    speedSlow: searchParams.get('speedSlow')
      ? parseInt(searchParams.get('speedSlow') || '')
      : 1000,
    titleFontSize: searchParams.get('titleFontSize') || '7',
    sizeQR: searchParams.get('sizeQR') || '30.8',
    paddingQR: searchParams.get('paddingQR') || '0',

    // qrTitle1: searchParams.get('qrTitle1'),
    // qrTitle2: searchParams.get('qrTitle2'),
    // phoneNumber,
    // sizeLogo: searchParams.get('sizeLogo') || '39.6',
    // logo: searchParams.get('logo') || null,
    // socials: searchParams.get('socials'),
    // phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || '5',
  };
};
